<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
          bordered
          :dynamicColumnSetting="false"
          :needPage="false"
          :columns="columns"
          v-model:search="searchFrom"
          @fetch="fetch"
          ref="tableRef"
          tableId="lbuSalesCoachingReport"
          id="lbuSalesCoachingReport"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="维度">
              <a-radio-group v-model:value="searchFrom.queryType" optionType="button" :options="dimensionEnum" @change="search" />
            </dc-form-item>
            <dc-form-item label="辅导时间">
              <cos-range-picker v-model:startTime="searchFrom.startTime" v-model:endTime="searchFrom.endTime" />
            </dc-form-item>
            <dc-form-item label="辅导人区域">
              <CosStaticSelect
                  :fieldNames="{ label: 'label', value: 'id' }"
                  :options="deptInfo4List"
                  mode="multiple"
                  v-model:value="searchFrom.deptLevel4List"
              />
            </dc-form-item>
            <dc-form-item label="辅导人组">
              <CosCascader
                  placeholder="请选择"
                  type="search"
                  :options="deptInfo4List"
                  :fieldNames="{ label: 'label', value: 'id', children: 'children' }"
                  appId="cos_lbu"
                  multiple
                  v-model:ids="searchFrom.deptLevel5List"
              />
            </dc-form-item>
            <dc-form-item label="辅导人">
              <UserSelect permission v-model:value="searchFrom.employeeNoList" mode="multiple" allowClear />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button @click="exportRows" v-permission="'lbu_sales_coaching_report_export_btn'"> 导出 </a-button>
        </template>
        <template #bodyCell="{ column, text, record}">
          <template v-if="column.route === 'salesCoaching'">
              <router-link
                v-if="searchFrom.queryType===3"
                class="ant-table-cell-ellipsis"
                :to="{ path: '/lbu/saleCoaching', query: { queryParams: JSON.stringify(routeFilterParams(
                  column.status ? column.status : undefined,
                  record.employeeNo)) } }"
                :title="text"
              >{{ text === undefined || text === null ?'--':text }}
              </router-link>
            <p v-else>{{ text === undefined || text === null ?'--':text }}</p>
          </template>
          <template v-if="column.route === 'salesSkillsCoaching'">
            <router-link
              v-if="searchFrom.queryType===3"
              class="ant-table-cell-ellipsis"
              :to="{ path: '/lbu/salesSkillsCoaching', query: { queryParams: JSON.stringify(routeFilterParams(
                column.status ? column.status : undefined,
                record.employeeNo)) } }"
              :title="text"
            >{{ text === undefined || text === null ?'--':text }}
            </router-link>
            <p v-else>{{ text === undefined || text === null ?'--':text }}</p>
          </template>
        </template>

      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { reactive, computed, ref, onMounted } from 'vue'
import { LbuSalesWorkReportParams } from '@/api/yuntuSales/salesWorkReport'
import { getDeptInfo } from '@/api/common'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import CosStaticSelect from '@/components/CosStaticSelect'
import dayjs from 'dayjs'
import { salesCoachingReport } from '@/api/yuntuSales/analysis'
import { cloneDeep } from 'lodash-es'
const deptInfo4List = ref([])

const tableRef = ref()
const searchFrom = reactive<any>({
  queryType: 1,
  startTime: dayjs().startOf('month').format('YYYY/MM/DD 00:00:00'),
  endTime: dayjs().endOf('month').format('YYYY/MM/DD 23:59:59')
})
const searchSuccessParams = ref<any>({})
const routeFilterParams = (status: number|undefined, employeeNo: string|undefined) => {
  const params:any = {}
  params.mentorList = employeeNo ? [employeeNo] : undefined
  params.tutoringStartTime = searchSuccessParams.value.startTime || undefined
  params.tutoringEndTime = searchSuccessParams.value.endTime || undefined
  params.status = status
  return params
}
const fetch = (searchFrom: LbuSalesWorkReportParams, callBack: (res: any) => void) => {
  // const params = customerListFormat(searchFrom) // 处理客户名称和客户编码的批量查询参数
  salesCoachingReport(searchFrom).then((res) => {
    searchSuccessParams.value = cloneDeep(searchFrom)
    callBack(res)
  })
}

const search = () => {
  tableRef.value.search()
}

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})

const dimensionEnum = [
  { value: 1, label: '区域' },
  { value: 2, label: '组', color: '#EF8D3C', desc: '' },
  { value: 3, label: '销售员', color: '#3FAC46', desc: '' }
]

const customSorter = (dataIndex: string) => {
  return (a: any, b: any, sortOrder?: 'ascend' | 'descend') => {
    if (a.deptLevel4Name === '合计') return sortOrder === 'ascend' ? 1 : -1

    return a[dataIndex] > b[dataIndex] ? 1 : -1
  }
}


const columns = computed(() => {
  const columns = [
    {
      title: '',
      width: 450,
      children: [
        { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name', width: 100 },
        { title: '组', fixed: 'left', dataIndex: 'deptLevel5Name', width: 100 },
        { title: '销售员', fixed: 'left', dataIndex: 'employeeName', width: 100 }
      ]
    },
    {
      title: '总计(已提交+已确认)',
      width: 270,
      children: [
        { title: '小计', fixed: 'left', dataIndex: 'salesCoachingTotal1', width: 70, sorter: customSorter('salesCoachingTotal1') },
        { title: '销售业绩辅导', fixed: 'left', dataIndex: 'salesCoachingTotal2', route: 'salesCoaching', width: 100, sorter: customSorter('salesCoachingTotal2') },
        { title: '销售技能辅导', fixed: 'left', dataIndex: 'salesCoachingTotal3', route: 'salesSkillsCoaching', width: 100, sorter: customSorter('salesCoachingTotal3') }
      ]
    },
    {
      title: '已提交',
      width: 270,
      children: [
        { title: '小计', dataIndex: 'salesCoachingTotal4', width: 70, sorter: customSorter('salesCoachingTotal4') },
        { title: '销售业绩辅导', dataIndex: 'salesCoachingTotal5', route: 'salesCoaching', status: 1, width: 100, sorter: customSorter('salesCoachingTotal5') },
        { title: '销售技能辅导', dataIndex: 'salesCoachingTotal6', route: 'salesSkillsCoaching', status: 1, width: 100, sorter: customSorter('salesCoachingTotal6') }
      ]
    },
    {
      title: '已确认',
      width: 270,
      children: [
        { title: '小计', dataIndex: 'salesCoachingTotal7', width: 70, sorter: customSorter('salesCoachingTotal7') },
        { title: '销售业绩辅导', dataIndex: 'salesCoachingTotal8', route: 'salesCoaching', status: 2, width: 100, sorter: customSorter('salesCoachingTotal8') },
        { title: '销售技能辅导', dataIndex: 'salesCoachingTotal9', route: 'salesSkillsCoaching', status: 2, width: 100, sorter: customSorter('salesCoachingTotal9') }
      ]
    }
  ]
  if (searchFrom.queryType && searchFrom.queryType < 3) {
    columns[0].children.splice(2, 1)
    columns[0].width = columns[0].width - 100
  }

  if (searchFrom.queryType && searchFrom.queryType < 2) {
    columns[0].children.splice(1, 1)
    columns[0].width = columns[0].width - 100
  }

  return columns
})

const exportRows = () => {
  const et = XLSX.utils.table_to_book(document.querySelector('#lbuSalesCoachingReport'))
  const etout = XLSX.write(et, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      new Blob([etout], {
        type: 'application/octet-stream'
      }),
      `销售辅导情况${dayjs().format('YYYYMMDDHHmmss')}.xlsx`
    )
  } catch (e) {
    console.log(e, etout)
  }
  return etout
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesCoachingReport' }
</script>

<style scoped></style>
